import Product from '../Models/Product';
import DataGridRequest from './DataGridRequest';
export class ProductRequest extends DataGridRequest<Product> {
    Url = 'products/api';
}
